import { z } from 'zod';
import { sizeSchema, coordinateSchema } from '../../../Shared.js';

const imageItemSchema = z.object({
  kind: z.literal("image"),
  id: z.string(),
  src: z.string(),
  alt: z.string().nullish().default(null),
  longDesc: z.string().nullish().default(null),
  thumbnail: z.string().optional(),
  fileName: z.string(),
  updatedAt: z.number().default(Date.now()),
  position: coordinateSchema,
  size: sizeSchema,
  naturalSize: sizeSchema,
  angleInRadian: z.number(),
  settings: z.object({
    cloneable: z.boolean().default(false),
    movable: z.boolean().default(false),
    showCrediting: z.boolean().default(false),
    hideDragHandle: z.boolean().optional()
  }).nullish().default({ cloneable: false, movable: false, showCrediting: false }),
  crediting: z.object({
    title: z.string(),
    description: z.string(),
    author: z.string(),
    creditLine: z.string(),
    year: z.string()
  })
});

export { imageItemSchema };
//# sourceMappingURL=Image.js.map
